import React from 'react';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Textarea } from '../ui/textarea';
import { Star, Clock } from 'lucide-react';

export function ReviewDialog({
  open,
  onOpenChange,
  booking,
  rating,
  setRating,
  reviewText,
  setReviewText,
  onSubmit,
  reviewType = 'client_to_provider',
  disabled = false,
  disabledReason = '',
}) {
  const isClientReview = reviewType === 'client_to_provider';
  const title = isClientReview
    ? `Review ${booking.service_name}`
    : `Review ${booking.client_name || 'Client'}`;
  const placeholder = isClientReview
    ? 'Share your experience with this service...'
    : 'Share your experience with this client...';
  const triggerLabel = isClientReview ? 'Leave Review' : 'Review Client';

  if (disabled) {
    return (
      <Button variant="outline" className="border-stone-200 text-stone-400 gap-1 cursor-not-allowed" disabled data-testid={`review-disabled-${booking.booking_id}`}>
        <Clock className="h-4 w-4" />{disabledReason || 'Review unavailable'}
      </Button>
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button className="btn-primary gap-1" data-testid={`leave-review-${booking.booking_id}`}>
          <Star className="h-4 w-4" />{triggerLabel}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-heading text-xl">{title}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div>
            <label className="text-sm font-medium text-[#1A1A1A] mb-2 block">Rating</label>
            <div className="flex gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <button key={star} onClick={() => setRating(star)} className="p-1" data-testid={`star-${star}`}>
                  <Star className={`h-8 w-8 ${star <= rating ? 'text-[#D4AF37] fill-current' : 'text-stone-300'}`} />
                </button>
              ))}
            </div>
          </div>
          <div>
            <label className="text-sm font-medium text-[#1A1A1A] mb-2 block">Your Review</label>
            <Textarea
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              placeholder={placeholder}
              className="input-zuriya min-h-[100px]"
              data-testid="review-text-input"
            />
          </div>
          <Button onClick={onSubmit} className="w-full btn-primary" data-testid="submit-review-btn">
            Submit Review
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
